// Read, on the class-notes page: opens an upload's notes in the main column,
// in place of "What your notes cover", without leaving the page. The server
// renders the reader (`?panel=1` is it alone); this swaps it in, keeps the
// address bar on the upload's own URL so a reload or a shared link lands on
// the same view, and the × (or Back) puts the coverage back — it was never
// removed, only hidden, so closing asks the server for nothing.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside class_notes_poll.js. Without this module every
// link here is a plain link to a page that renders the same view.

import typesetMath from "./math_typeset";

function setup() {
  const main = document.querySelector("[data-class-notes-main]");
  if (main === null) return;

  const reader = main.querySelector("[data-class-notes-reader]");
  const coverage = main.querySelector("[data-class-notes-coverage]");
  const indexPath = main.dataset.classNotesIndex;
  let pending = null;

  function markCurrent(param) {
    document.querySelectorAll("[data-class-notes-upload]").forEach((row) => {
      const current = row.dataset.classNotesUpload === param;
      row.classList.toggle("class-notes__upload-row--reading", current);
      const link = row.querySelector("[data-class-notes-read]");
      if (link) link.toggleAttribute("aria-current", current);
    });
  }

  function landOn(hash) {
    const target = hash ? reader.querySelector(hash) : null;
    if (target) {
      target.scrollIntoView({ block: "start" });
    } else {
      main.scrollIntoView({ block: "start" });
      const title = reader.querySelector("#class-notes-read-title");
      if (title) title.focus({ preventScroll: true });
    }
  }

  function open(href, param, push) {
    const url = new URL(href, window.location.href);
    const panel = new URL(url);
    panel.hash = "";
    panel.searchParams.set("panel", "1");

    // A second press before the first answers wins; the first is dropped.
    const ticket = {};
    pending = ticket;
    return fetch(panel, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then((html) => {
        if (pending !== ticket) return;
        reader.innerHTML = html;
        reader.hidden = false;
        coverage.hidden = true;
        markCurrent(param);
        if (push) window.history.pushState({ classNotes: param }, "", url.pathname + url.hash);
        typesetMath(reader);
        landOn(url.hash);
      })
      .catch(() => { if (pending === ticket) window.location.assign(url); });
  }

  function close(push) {
    pending = null;
    reader.hidden = true;
    reader.innerHTML = "";
    coverage.hidden = false;
    markCurrent(null);
    if (push) window.history.pushState({ classNotes: null }, "", indexPath);
    main.scrollIntoView({ block: "start" });
  }

  document.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const read = event.target.closest("[data-class-notes-read]");
    if (read) {
      event.preventDefault();
      open(read.href, read.dataset.classNotesRead, true);
      return;
    }
    if (event.target.closest("[data-class-notes-close]")) {
      event.preventDefault();
      close(true);
    }
  });

  // Opened from a link that named a page: the browser's own jump ran before
  // the page settled, so land on it again once it has.
  if (!reader.hidden && window.location.hash) {
    window.requestAnimationFrame(() => landOn(window.location.hash));
  }

  // Back and Forward walk the same two views. The upload is named by the
  // path, so it is read back from the address bar, not from state.
  window.addEventListener("popstate", () => {
    if (window.location.pathname === indexPath) return close(false);

    const row = Array.from(document.querySelectorAll("[data-class-notes-upload]"))
      .find((el) => window.location.pathname.endsWith(`/${el.dataset.classNotesUpload}`));
    if (row) return open(window.location.href, row.dataset.classNotesUpload, false);
    return window.location.reload();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
